import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsEncyclopediaPage } from 'types/cms/single-types'

/**
 * Get the encyclopedia page from the CMS
 *
 * @param {Language} locale
 * @returns {Promise<CmsEncyclopediaPage | undefined>}
 */
const getEncyclopediaPage = async (locale: Language = Language.DUTCH): Promise<CmsEncyclopediaPage | undefined> => {
  try {
    const {
      data: { data }
    } = await axios.get<CMSApiResponseBody<CmsEncyclopediaPage>>(`${process.env.CMS_API_URL}/encyclopedia?locale=${locale}`)

    return data
  } catch (_) {
    return undefined
  }
}

export default getEncyclopediaPage
